import { branchLiveStates } from '@ourbranch/lookups';
import type { BrandProduct } from '../types';

export const branch = {
  identity: {
    SHORT_NAME: 'Branch',
    FULL_NAME: 'Branch Insurance',
    LEGAL_NAME: 'Branch Insurance Exchange',
    EMAIL_SENDER: 'Branch Insurance',
    EMAIL_BCC: 'sendgridbcc@ourbranch.com',
    SUPPORT_NAME: 'Branch Insurance',
    DOMAIN: 'ourbranch.com',
    SUPPORT_EMAIL: 'support@ourbranch.com',
    DISPLAY_NAME: 'Branch',
    MARKETING_NAME: 'Branch Insurance',
    POLICY_ISSUER: 'Branch Insurance Exchange',
    CLAIMS_HANDLER: 'Branch',
    REFERRAL_NAME: 'Branch Insurance',
    SOCIAL_HANDLE: 'Branch',
    AGENCY_SUPPORT_EMAIL: 'agencysupport@ourbranch.com',
    PAYMENT_ADDRESS: 'Branch Payments, PO Box 15010, Worcester, MA 01615',
    EXPEDITED_PAYMENT_ADDRESS: 'Branch c/o Covenir, 370 Main St, Suite 880, Worcester, MA 01608',
    CUSTOMER_SERVICE_PHONE: '833-427-2624',
    CUSTOMER_SERVICE_PHONE_LETTERS: '833-4BRANCH',
    PRIVACY_POLICY_URL: 'https://www.ourbranch.com/s/blog/privacy-policy'
  },
  supportedStates: branchLiveStates,
  // Branch keeps the legacy "rateControlDate must be today" bind rule (issue #32130).
  rateControlDate: { maxStaleDaysToBind: 0, underwriterMaxHoldDays: 0 },
  // Branch: 8-day billing-hold cap (unchanged), no reason required, no "hold cancellations" option (#33568).
  billingHold: { maxDays: 8, requireReason: false, holdCancellationsEnabled: false },
  // Rental needs Collision and Comprehensive, Roadside needs Collision, Lease/Loan Gap needs both (#37618).
  autoCoverageDependencies: {
    rentalRequiresCollision: true,
    roadsideRequiresCollision: true,
    loanRequiresPhysicalDamage: true,
    leaseLoanOffered: true
  },
  typeformUrls: {
    helpRequest: 'https://ourbranch.typeform.com/to/pJtULI6B',
    agencySupport: 'https://ourbranch.typeform.com/to/QsfFE7NK',
    phoneQuoteIntake: 'https://ourbranch.typeform.com/to/QKIHcyvn',
    postClaimSurvey: 'https://ourbranch.typeform.com/to/Wvtu8l9Q'
  }
} satisfies BrandProduct;
